import { useTenantCustomizations } from "src/tenantCustomizations/TenantCustomizationsContext.ts";
import i18n from "i18next";
import type { InventoryForecastCustomFilterComponentProps } from "src/components/views/erp/production/reports/inventoryForecast/InventoryForecastViewBase.tsx";
import { encodeObjectAttributeValue } from "src/components/views/erp/objectAttributes/objectAttributeValueConverting.ts";
import { InventoryForecastCustomerOrderLineFilter } from "src/api/generated/erp/production/reports/inventoryForecast/model/inventoryForecastCustomerOrderLineFilter.ts";
import { AavoMultiSelectField } from "../../../../components/common/inputFields/AavoMultiSelectField.tsx";
import { filterNulls } from "src/utils/arrayUtils.ts";

export const SalvosInventoryForecastCustomFilters = ({
	currentFilters,
	setFilters,
}: InventoryForecastCustomFilterComponentProps) => {
	const { tenantConfig } = useTenantCustomizations();

	return (
		<>
			<AavoMultiSelectField
				label={i18n.t("salvos_state")}
				options={tenantConfig.erp.customerOrderTenantStates}
				getOptionKey={(o) => o.key}
				getOptionLabel={(o) => o.label}
				onChange={(tenantStates) => {
					const filters: InventoryForecastCustomerOrderLineFilter[] = currentFilters.filter(
						(f) => f.type !== "CUSTOMER_ORDER_TENANT_STATE",
					);
					if (tenantStates.length > 0)
						filters.push({
							type: "CUSTOMER_ORDER_TENANT_STATE",
							customerOrderTenantStateIn: tenantStates,
						});

					setFilters(filters);
				}}
			/>
			<AavoMultiSelectField
				label={"Rakennuslupa"}
				options={["Rakennuslupa", "Salvos hakee luvan", "Poikkeuslupa", "Lupavapaa rakennus"]}
				getOptionKey={(o) => o}
				getOptionLabel={(o) => o}
				onChange={(newSelections) => {
					const filters = currentFilters.filter(
						(f) =>
							!(
								f.type === "CUSTOMER_ORDER_ATTRIBUTE" &&
								f.attributeFieldId === BUILDING_LICENSE_ATTRIBUTE_FIELD_ID
							),
					);

					const encodedAttributeValues = filterNulls(
						newSelections.map((selection) =>
							encodeObjectAttributeValue({
								type: "selection",
								value: [selection],
							}),
						),
					);
					if (encodedAttributeValues.length > 0)
						filters.push({
							type: "CUSTOMER_ORDER_ATTRIBUTE",
							attributeFieldId: BUILDING_LICENSE_ATTRIBUTE_FIELD_ID,
							attributeValueIn: encodedAttributeValues,
						});

					setFilters(filters);
				}}
			/>
		</>
	);
};

const BUILDING_LICENSE_ATTRIBUTE_FIELD_ID = 8;
